angular.module("iconoglobe")
.constant("APP_VERSION", {"version":"f7d70a35e0d606b1493a2208b235415a147f5f0b"});
